import { NavigateFunction } from "react-router-dom";
import config from "../../config";
import { ProblemData } from "./problemTypes";
import { authFetch } from "../Security/authFetch";
import ses from "../../Assets/ses.jpg";
import { getSignatureLines } from "../emailSignature";

const email = localStorage.getItem("email");

const postMessage = async (payload: any) => {
  return authFetch(`${config.apiBaseUrl}/api/messages`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
};

export const handleEdit = async (
  data: ProblemData,
  navigate: NavigateFunction,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";

  const payload = {
    username,
    message: `Problem With Id ${data.ticketId} Edited.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const res = await postMessage(payload);
    if (res.ok) fetchMessages();
    else console.error("Failed to save message");
  } catch (e) {
    console.error("Error while saving message:", e);
  }

  navigate(`/problem-edit/${data.ticketId}`, { state: { problem: data } });
};

export const handleAccept = async (
  data: ProblemData,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Problem With Id ${data.ticketId} Accepted.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/problems/${data.ticketId}/accept`,
      { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to accept or save message");
    }
  } catch (e) {
    console.error("Error while accepting problem:", e);
  }
  try {
    const emails = ["c.hanna@bcomsat.com", "g.kattan@bcomsat.com"];

    await authFetch(`${config.apiBaseUrl}/api/email/send`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify({
        to: emails,
        subject: `A problem with ID ${data.ticketId} has been Accepted.`,

        body: `
                       A ticket with ID: ${
                         data.ticketId
                       } has been accepted with the following comment <br><br>

              Ticket ID:${data.ticketId}<br><br>
Status: In progress<br><br>
Problem creation date/time:  ${data.problemStartDatetime?.replace(
          "T",
          " "
        )}<br><br>
Problem closure date/time:  ${
          data.problemCloseDatetime
            ? data.problemCloseDatetime.replace("T", " ")
            : " "
        }<br><br>
Customer: ${data.affectedCustomer} <br><br>
Network:  ${data.affectedNetwork}<br><br>
Site: ${data.affectedSite} <br><br>
Link: ${data.affectedLink} <br><br>
Summary: ${data.summary ?? " "} <br><br>
Description: ${data.description ?? " "} <br><br>
Error Type: ${data.errorType ?? " "} <br><br>
Closure Code: ${data.closureCode ?? " "} <br><br>
Solution  : ${data.solution ?? " "} <br><br>



              <br><br>
              <p>Regards,<br><br><br><br></p>
              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Problem Details
              </a>
            </p>
            
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
      </div>
            `,
      }),
    });
    //console.log("Email sent successfully!");
  } catch (emailErr) {
    console.error("Failed to send email notification:", emailErr);
  }
};

export const handleClose = async (
  data: ProblemData,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Problem With Id ${data.ticketId} Closed.
    Error Type: ${data.errorType}  | Solution: ${data.solution} | Closure Code: ${data.closureCode}`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/problems/${data.ticketId}/close`,
      {
        method: "PUT",
      }
    );

    try {
      const emails = ["c.hanna@bcomsat.com", "g.kattan@bcomsat.com"];

      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: emails,
          subject: `A Problem With Id: ${data.ticketId} has been Closed`,
          body: `
                                 A ticket with ID: ${
                                   data.ticketId
                                 } has been closed with the following comment<br><br>

              Ticket ID:${data.ticketId ?? " "}<br><br>
Status: Closed<br><br>
Problem creation date/time:  ${data.problemStartDatetime?.replace(
            "T",
            " "
          )}<br><br>
Problem closure date/time:  ${
            data.problemCloseDatetime
              ? data.problemCloseDatetime.replace("T", " ")
              : " "
          }<br><br>
Customer: ${data.affectedCustomer ?? " "} <br><br>
Network:  ${data.affectedNetwork}<br><br>
Site: ${data.affectedSite} <br><br>
Link: ${data.affectedLink} <br><br>
Summary: ${data.summary ?? " "} <br><br>
Description: ${data.description ?? " "} <br><br>
Error Type: ${data.errorType ?? " "} <br><br>
Closure Code: ${data.closureCode ?? " "} <br><br>
Solution  : ${data.solution ?? " "} <br><br>



              <br><br>
             <p>Regards,<br><br><br><br></p>
              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Problem Details
              </a>
            </p>
            
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
      </div>
            `,
        }),
      });
      //console.log("Email sent successfully!");
    } catch (emailErr) {
      console.error("Failed to send email notification:", emailErr);
    }

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to Close or save message");
    }
  } catch (e) {
    console.error("Error while Closing problem:", e);
  }
};

export const handlePause = async (
  data: ProblemData,
  fetchMessages: () => void
) => {
  const comment = localStorage.getItem("comment");
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Problem With Id ${data.ticketId} Paused.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/problems/${data.ticketId}/pause`,
      {
        method: "PUT",
      }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to Pause or save message");
    }
  } catch (e) {
    console.error("Error while Pausing problem:", e);
  }

  try {
    const emails = ["c.hanna@bcomsat.com", "g.kattan@bcomsat.com"];

    await authFetch(`${config.apiBaseUrl}/api/email/send`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify({
        to: emails,
        subject: `A Problem With Id: ${data.ticketId} has been Paused`,
        body: `
      A ticket with ID: ${
        data.ticketId
      } has been paused with the following comment<br>

              Ticket ID:${data.ticketId ?? " "}<br><br>
Status: Paused <br><br>
Problem creation date/time:  ${data.problemStartDatetime?.replace(
          "T",
          " "
        )}<br><br>
Problem closure date/time:  ${
          data.problemCloseDatetime
            ? data.problemCloseDatetime.replace("T", " ")
            : " "
        }<br><br>
Customer: ${data.affectedCustomer ?? " "} <br><br>
Network:  ${data.affectedNetwork}<br><br>
Site: ${data.affectedSite} <br><br>
Link: ${data.affectedLink} <br><br>
Summary: ${data.summary ?? " "} <br><br>
Description: ${data.description ?? " "} <br><br>
Error Type: ${data.errorType ?? " "} <br><br>
Closure Code: ${data.closureCode ?? " "} <br><br>
Solution  : ${data.solution ?? " "} <br><br>
Comment : ${comment ?? " "}<br><br>



              <br><br>
 <p>Regards,<br><br><br><br></p>
              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Problem Details
              </a>
            </p>
            
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
      </div>
            `,
      }),
    });
    //console.log("Email sent successfully!");
  } catch (emailErr) {
    console.error("Failed to send email notification:", emailErr);
  }
};

export const handleReactivate = async (
  data: ProblemData,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Problem With Id ${data.ticketId} Reactivated.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/problems/${data.ticketId}/reactivate`,
      { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to Reactivate or save message");
    }
  } catch (e) {
    console.error("Error while Reactivating problem:", e);
  }
  //console.log("emaaaaaaiiiiiiiiiiilllllllllllllll", email);
  try {
    const emails = ["c.hanna@bcomsat.com", "g.kattan@bcomsat.com"];

    await authFetch(`${config.apiBaseUrl}/api/email/send`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify({
        to: emails,
        subject: `A Problem With Id: ${data.ticketId} has been Reactivated`,
        body: `
                               A ticket with ID: ${
                                 data.ticketId
                               } has been reactivated with the following comment<br><br>

              Ticket ID:${data.ticketId ?? " "}<br><br>
Status: Reactivated <br><br>
Problem creation date/time:  ${data.problemStartDatetime?.replace(
          "T",
          " "
        )}<br><br>
Problem closure date/time:  ${
          data.problemCloseDatetime
            ? data.problemCloseDatetime.replace("T", " ")
            : " "
        }<br><br>
Customer: ${data.affectedCustomer ?? " "} <br><br>
Network:  ${data.affectedNetwork}<br><br>
Site: ${data.affectedSite} <br><br>
Link: ${data.affectedLink} <br><br>
Summary: ${data.summary ?? " "} <br><br>
Description: ${data.description ?? " "} <br><br>
Error Type: ${data.errorType ?? " "} <br><br>
Closure Code: ${data.closureCode ?? " "} <br><br>
Solution  : ${data.solution ?? " "} <br><br>



              <br><br>
              <p>Regards,<br><br><br><br></p>
              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Problem Details
              </a>
            </p>
            
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
      </div>
            `,
      }),
    });
    //console.log("Email sent successfully!");
  } catch (emailErr) {
    console.error("Failed to send email notification:", emailErr);
  }
};

export const handleReopen = async (
  data: ProblemData,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Problem With Id ${data.ticketId} Reopened.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/problems/${data.ticketId}/reopen`,
      { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to Reactivate or save message");
    }
  } catch (e) {
    console.error("Error while Reactivating problem:", e);
  }

  try {
    const emails = ["c.hanna@bcomsat.com", "g.kattan@bcomsat.com"];

    await authFetch(`${config.apiBaseUrl}/api/email/send`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify({
        to: emails,
        subject: `A Problem With Id: ${data.ticketId} Is Reopened`,
        body: `
                               A ticket with ID: ${
                                 data.ticketId
                               } has been reopened with the following comment <br><br>

              Ticket ID:${data.ticketId ?? " "}<br><br>
Status: Reopened<br><br>
Problem creation date/time:  ${data.problemStartDatetime?.replace(
          "T",
          " "
        )}<br><br>
Problem closure date/time:  ${
          data.problemCloseDatetime
            ? data.problemCloseDatetime.replace("T", " ")
            : " "
        }<br><br>
Customer: ${data.affectedCustomer ?? " "} <br><br>
Network:  ${data.affectedNetwork}<br><br>
Site: ${data.affectedSite} <br><br>
Link: ${data.affectedLink} <br><br>
Summary: ${data.summary ?? " "} <br><br>
Description: ${data.description ?? " "} <br><br>
Error Type: ${data.errorType ?? " "} <br><br>
Closure Code: ${data.closureCode ?? " "} <br><br>
Solution  : ${data.solution ?? " "} <br><br>



              <br><br>
              <p>Regards,<br><br><br><br></p>
              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Problem Details
              </a>
            </p>
            
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
      </div>
            `,
      }),
    });
    //console.log("Email sent successfully!");
  } catch (emailErr) {
    console.error("Failed to send email notification:", emailErr);
  }
};
